import React from 'react';

export default function () {
  return <div className="ming Input w100 disabled"></div>;
}
